import React from 'react';

import { Button, Modal, Stack, Text, ThemeIcon, Title } from '@mantine/core';
import { IconCircleCheck } from '@tabler/icons-react';

interface IProgramReadyModalProps {
  opened: boolean;
  onGoToTracking: () => void;
}

const ProgramReadyModal = ({ opened, onGoToTracking }: IProgramReadyModalProps): JSX.Element => (
  <Modal centered opened={opened} onClose={onGoToTracking} withCloseButton={false} size='md'>
    <Stack align='center' spacing='md' p='md'>
      <ThemeIcon size={64} radius='xl' variant='light' color='green'>
        <IconCircleCheck size={40} />
      </ThemeIcon>
      <Title order={3} align='center'>
        Your Committed Club program is now active!
      </Title>
      <Text color='dimmed' align='center'>
        Head to the tracking page to see your athletes&apos; progress in real time.
      </Text>
      <Button fullWidth onClick={onGoToTracking}>
        Go to tracking
      </Button>
    </Stack>
  </Modal>
);

export default ProgramReadyModal;
